// پیکربندی Console از متغیرهای Vite (مقادیر پیش‌فرض فقط توسعه محلی؛ keycloak-setup.md §۲.۱).
export const consoleConfig = {
  oidcAuthority: import.meta.env.VITE_OIDC_AUTHORITY ?? 'http://localhost:8080/realms/phoenix-staff',
  oidcClientId: import.meta.env.VITE_OIDC_CLIENT_ID ?? 'phoenix-console',
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? '',
};

/** نسخه کنسول پلتفرم؛ همان شماره محصول که روی phcadmin منتشر می‌شود. */
export const APP_VERSION: string = import.meta.env.VITE_APP_VERSION ?? '0.1.0';
